// extracted by mini-css-extract-plugin
module.exports = {"link-default":"_6444e049b8--link-default--Cv1gB"};